import React from 'react'
import { useMemo, useState } from 'react'
import BalanceTransferPage from './modules/BalanceTransferPage'
import PaymentAccountsPage from './modules/PaymentAccountsPage'
import TransactionHistoryPage from './modules/TransactionHistoryPage'

const tabs = [
  {
    id: 'queue',
    label: 'Action queue',
    description: 'Review and process pending transfers',
    component: BalanceTransferPage,
  },
  {
    id: 'accounts',
    label: 'Payment accounts',
    description: 'Manage bank accounts and wallets',
    component: PaymentAccountsPage,
  },
  {
    id: 'history',
    label: 'History',
    description: 'Browse completed deposits & withdrawals',
    component: TransactionHistoryPage,
  },
]

const BalanceTransfer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0])
  const ActiveComponent = useMemo(() => activeTab.component, [activeTab])

  return (
    <div className="flex min-h-full flex-col gap-3 p-4 lg:p-6">
      <header className="rounded-xl border border-customSurface/10 bg-white p-4 shadow-md shadow-customSurface/20 dark:border-customSurface dark:bg-customSurface">
        <nav className="flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const isActive = tab.id === activeTab.id
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab)}
                className={`group flex min-w-[180px] flex-col gap-1 rounded-2xl border px-4 py-3 text-left transition ${
                  isActive
                    ? 'border-transparent bg-customAccentBlue dark:bg-customAccent text-white shadow-lg shadow-customAccentBlue/30 dark:shadow-customAccent/30'
                    : 'border-customAccentBlue/30 bg-white text-customPrimaryText hover:border-customAccentBlue/40 hover:bg-customAccentBlue/5 dark:bg-customSurface dark:text-customHeading'
                }`}
              >
                <span className="text-sm font-semibold">{tab.label}</span>
                <span
                  className={`text-xs ${
                    isActive
                      ? 'text-white/80'
                      : 'text-customSecondaryText dark:text-customMuted'
                  }`}
                >
                  {tab.description}
                </span>
              </button>
            )
          })}
        </nav>
      </header>
      <section className="min-h-[60vh]">
        <ActiveComponent />
      </section>
    </div>
  )
}

export default BalanceTransfer
